module.exports = __webpack_public_path__ + "img/mm-landing.93731262.jpg";